<template>
  <v-sheet :width="width" rounded="sm" class="pl-2 back-button">
    <v-list-item class="py-0 px-0" @click="$emit('click')">
      <v-list-item-icon class="mr-0">
        <v-icon small> mdi-chevron-left</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-subtitle>{{ text }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-sheet>
</template>

<script>
export default {
  props: {
    text: { type: String, default: "Back" },
    width:{type:String, default:"165"}
  },
};
</script>

<style>
.back-button .v-list-item--link:hover {
  border-radius: 8px 8px 8px 8px !important;
}
.back-button .v-list-item--link:before {
  border-radius: 8px 8px 8px 8px !important;
}
</style>